var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"batch-banner",class:`batch-banner-${_vm.batch.status}`},[_c('batch-status-badge',{attrs:{"status":_vm.batch.status,"size":"md"}}),_c('div',{staticClass:"batch-banner-message",domProps:{"innerHTML":_vm._s(_vm.message)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }